<template>
  <v-card>
    <v-toolbar flat>
      <span class="headline">More Details</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="hideDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text>
      <v-row v-if="hasBeforeAfter">
        <v-col cols="6">
          <strong class="f-s-16">Before</strong>
        </v-col>
        <v-col cols="6">
          <strong class="f-s-16">After</strong>
        </v-col>
      </v-row>
      <template v-if="assist.tool.isNotEmpty(otherDiffData)">
        <v-layout v-for="(item, index) in otherDiffData" :key="assist.tool.getRandomKey(index)">
          <v-flex lg2 class="f-w-500">{{ assist.tool.adapterKey(Object.keys(item)[0]) }}: </v-flex>
          <v-flex lg4 class="text-danger">{{ assist.tool.adapterValue(Object.keys(item)[0], item[Object.keys(item)[0]].before) }}</v-flex>
          <v-flex lg2 class="f-w-500 p-l-10">{{ assist.tool.adapterKey(Object.keys(item)[0]) }}: </v-flex>
          <v-flex lg4 class="text-success">{{ assist.tool.adapterValue(Object.keys(item)[0], item[Object.keys(item)[0]].after) }}</v-flex>
        </v-layout>
      </template>
      <v-row>
        <v-col cols="6">
          <arb-simple-table
            :desserts="diffData.original"
            :header="headers"
            :height="tableHeight"
            color="white"
          ></arb-simple-table>
        </v-col>
        <v-divider vertical></v-divider>
        <v-col cols="6">
          <arb-simple-table
            :desserts="diffData.current"
            :header="headers"
            :height="tableHeight"
            color="white"
          ></arb-simple-table>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="footer">
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="hideDialog">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { DataType, Tool } from '@/util/index'
import ArbSimpleTable from '../../../widget/table/SimpleTable'

export default {
  name: 'more-details-dialog',
  components: {
    ArbSimpleTable
  },
  props: {
    diffData: {
      type: Object,
      default: () => {}
    },
    otherDiffData: {
      type: Array,
      default: () => []
    },
    headers: {
      type: Array,
      default: () => []
    },
    tableHeight: {
      type: Number,
      default: 300
    },
    hasBeforeAfter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      assist: {
        tool: new Tool(),
        dataType: DataType
      }
    }
  },
  methods: {
    hideDialog () {
      this.$emit('hideDialog')
    }
  }
}
</script>
